import { FontIcon } from "@fluentui/react";
import { Tooltip } from "antd";
interface DownloadButtonProps {
  disabled?: boolean;
  onClick?: () => void;
}

function DownloadButton({ disabled, onClick }: DownloadButtonProps) {
  return (
    <Tooltip
      placement="bottom"
      title={"Download "}>
      <button
        disabled={disabled}
        className="button action"
        onClick={onClick}>
        <FontIcon iconName="Download" />
      </button>
    </Tooltip>
  );
}

export default DownloadButton;
